import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as styles from './gallery.module.scss';
import Img from "gatsby-image"

export const Gallery = ({ data }) => {
  const { images } = data;
  return (
    <div className={styles.withGallery}>
      <div
        className='container container-lg'
      >
        {!!images.length && (
          <div className={`${styles.images} no-margin`}>
            <div className={styles.col1}>
              {/* <GatsbyImage
                image={images[0].gatsbyImageData}
                alt={images[0].title}
                className={styles.image}
              /> */}
            <Img fluid={images[0].fluid} alt={images[0].title} className={styles.image}/>
            </div>
            <div className={styles.col2}>
              {/* <GatsbyImage
                image={images[1].gatsbyImageData}
                alt={images[1].title}
                className={styles.image}
              /> */}
              <Img fluid={images[1].fluid} alt={images[1].title} className={styles.image}/>
              {/* <GatsbyImage
                image={images[2].gatsbyImageData}
                alt={images[2].title}
                className={styles.image}
              /> */}
              <Img fluid={images[2].fluid} alt={images[2].title} className={styles.image}/>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}